
import Vue from 'vue'

export default Vue.extend({
   name: 'ChipComponent',
   props: {
      text: { type: String, default: '' },
      icon: { type: String, default: 'glyphicon-ok' },
      type: { type: String, default: 'success' },
   },
   computed: {
      typeClass(): string {
         return `alert-${this.type}`
      },
   },
})
